"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClaimFieldMappings = exports.ClaimFieldNames = void 0;
var ClaimFieldNames;
(function (ClaimFieldNames) {
    ClaimFieldNames["claimID"] = "claimID";
    ClaimFieldNames["approvedLenderCode"] = "approvedLenderCode";
    ClaimFieldNames["approvedLenderName"] = "approvedLenderName";
    ClaimFieldNames["approvedLenderReferenceNumber"] = "approvedLenderReferenceNumber";
    ClaimFieldNames["approvedLenderTransitNumber"] = "approvedLenderTransitNumber";
    ClaimFieldNames["claimTypeIndicator"] = "claimTypeIndicator";
    ClaimFieldNames["cmhcLoanAccountNumber"] = "cmhcLoanAccountNumber";
    ClaimFieldNames["correspondenceLanguage"] = "correspondenceLanguage";
    ClaimFieldNames["externalClaimStatus"] = "externalClaimStatus";
    ClaimFieldNames["internalClaimStatus"] = "internalClaimStatus";
    ClaimFieldNames["primaryBorrowerFirstName"] = "primaryBorrowerFirstName";
    ClaimFieldNames["primaryBorrowerLastName"] = "primaryBorrowerLastName";
    ClaimFieldNames["recordCreatedTimestamp"] = "recordCreatedTimestamp";
    ClaimFieldNames["recordCreatedUserFirstName"] = "recordCreatedUserFirstName";
    ClaimFieldNames["recordCreatedUserID"] = "recordCreatedUserID";
    ClaimFieldNames["recordCreatedUserLastName"] = "recordCreatedUserLastName";
    ClaimFieldNames["recordUpdatedTimestamp"] = "recordUpdatedTimestamp";
    ClaimFieldNames["recordUpdatedUserFirstName"] = "recordUpdatedUserFirstName";
    ClaimFieldNames["recordUpdatedUserID"] = "recordUpdatedUserID";
    ClaimFieldNames["recordUpdatedUserLastName"] = "recordUpdatedUserLastName";
    ClaimFieldNames["typeOfClaim"] = "typeOfClaim";
})(ClaimFieldNames = exports.ClaimFieldNames || (exports.ClaimFieldNames = {}));
var ClaimFieldMappings;
(function (ClaimFieldMappings) {
    ClaimFieldMappings["claimID"] = "claimID";
    ClaimFieldMappings["approvedLenderCode"] = "lender.approvedLenderCode";
    ClaimFieldMappings["approvedLenderName"] = "lender.approvedLenderName";
    ClaimFieldMappings["approvedLenderReferenceNumber"] = "approvedLenderReferenceNumber";
    ClaimFieldMappings["approvedLenderTransitNumber"] = "approvedLenderTransitNumber";
    ClaimFieldMappings["claimTypeIndicator"] = "claimTypeIndicator";
    ClaimFieldMappings["cmhcLoanAccountNumber"] = "cmhcLoanAccountNumber";
    ClaimFieldMappings["correspondenceLanguage"] = "lender.correspondenceLanguage";
    ClaimFieldMappings["externalClaimStatus"] = "operation.claimStatus.external";
    ClaimFieldMappings["internalClaimStatus"] = "operation.claimStatus.internal";
    ClaimFieldMappings["primaryBorrowerFirstName"] = "borrowers.0.firstName";
    ClaimFieldMappings["primaryBorrowerLastName"] = "borrowers.0.lastName";
    ClaimFieldMappings["recordCreatedTimestamp"] = "recordCreatedTimestamp";
    ClaimFieldMappings["recordCreatedUserFirstName"] = "recordCreatedUserFirstName";
    ClaimFieldMappings["recordCreatedUserID"] = "recordCreatedUserID";
    ClaimFieldMappings["recordCreatedUserLastName"] = "recordCreatedUserLastName";
    ClaimFieldMappings["recordUpdatedTimestamp"] = "recordUpdatedTimestamp";
    ClaimFieldMappings["recordUpdatedUserFirstName"] = "recordUpdatedUserFirstName";
    ClaimFieldMappings["recordUpdatedUserID"] = "recordUpdatedUserID";
    ClaimFieldMappings["recordUpdatedUserLastName"] = "recordUpdatedUserLastName";
    ClaimFieldMappings["typeOfClaim"] = "detail.typeOfClaim";
})(ClaimFieldMappings = exports.ClaimFieldMappings || (exports.ClaimFieldMappings = {}));
